<template>
  <v-row v-if="item">
    <v-col v-if="showIndex" cols="auto" align-self="center">
      <v-chip
          class="btn-round-border"
          outlined>
        {{ index !== 0 ? index : '' }}
      </v-chip>
    </v-col>
    <v-col class="px-0 py-2">
      <div class="d-flex">

        <div>
          <div class="text-body-1">
            {{ item.name }}
          </div>
          <div>
            <confirm-chip class="me-2"
                          green-red
                          :is-confirm="confirmed"
                          :text-yes='$t("ui.confirm")'
                          :text-no='$t("ui.notConfirmed")'
            />

            <span v-if="confirmed"> {{ formatDate(item.confirmTime, "HH:mm DD/MM/YYYY") }}</span>
            <span v-else> _ _ </span>

          </div>

        </div>
        <v-btn
            v-if="showExpand"
            icon
            class="ms-auto me-2"
            @click="onDefaultExpand">

          <img
              :src="item.expand ? require('@/assets/images/ic-arrow-up.svg') : require('@/assets/images/ic-arrow-down.svg')"/>

        </v-btn>

      </div>
    </v-col>
  </v-row>

</template>

<script>
import ConfirmChip from "../component/ConfirmChip";
import mixin from "../../mixin";

export default {
  components: {ConfirmChip},
  mixins: [mixin],
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    },
    showIndex: {
      type: Boolean,
      default: false
    },
    showExpand: {
      type: Boolean,
      default: false
    },
    onExpand: {
      type: Function,
      default: null
    },
  },
  computed: {
    confirmed() {
      return this.item ? this.item.isConfirm === 1 : false
    },
  },
  methods: {
    onDefaultExpand() {
      if (this.onExpand) this.onExpand()
      else this.item.expand = !this.item.expand
    }
  }
};
</script>

<style scoped>

.btn-round-border {
  width: 32px;
  height: 32px;
  background-color: #FFF1F0;
  border: 1px dashed #D9D9D9;
}

</style>
